import * as React from "react";
import * as ReactDOM from "react-dom";
import {BonusweltenContainer} from "./components/BonusweltenContainer";

const e = React.createElement;

const element = document.querySelector('#bonuswelten-component');

if (element) {
    ReactDOM.render(
        e(BonusweltenContainer, {...element.dataset}),
        element
    );
}
